const ALL_INTEREST_COLUMNS = [
  { key: 'mineral', label: 'Mineral' },
  { key: 'surface', label: 'Surface' },
  { key: 'executive', label: 'Exec' },
  { key: 'royalty', label: 'Royalty' },
  { key: 'bonus', label: 'Bonus' },
  { key: 'delay', label: 'Delay' },
  { key: 'working', label: 'WI' },
  { key: 'orri', label: 'ORRI' },
  { key: 'nri', label: 'NRI' },
] as const;

type ColumnKey = (typeof ALL_INTEREST_COLUMNS)[number]['key'];

export interface OwnershipTableConfig {
  visibleColumns: Set<ColumnKey>;
  decimalPlaces: number;
}

export const DEFAULT_OWNERSHIP_TABLE_CONFIG: OwnershipTableConfig = {
  visibleColumns: new Set(
    ALL_INTEREST_COLUMNS.map((c) => c.key)
  ) as Set<ColumnKey>,
  decimalPlaces: 8,
};
